module.exports = __webpack_public_path__ + "img/icon_1.e4099848.png";